  <div *ngIf="sessionSrv.showSpinner"
    class="spinner"
    [class.responsive]="sessionSrv.responsive"
   >
    <mat-spinner></mat-spinner>
    <p *ngIf="showTxt"> {{(sessionSrv.customSpinnerTxt ?? 'spinnerTxt') | translate}} </p>
  </div>

